import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Wallet } from "lucide-react";

const MONTH_LABELS = { "01": "Ene", "02": "Feb", "03": "Mar", "04": "Abr", "05": "May", "06": "Jun", "07": "Jul", "08": "Ago", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dic" };
const periodLabel = (p) => {
  if (!p || !p.includes("-")) return p || "—";
  const [y, m] = p.split("-");
  return `${MONTH_LABELS[m] || m} ${y}`;
};

/** Aviso simple (no bandeja operativa) de pago de viático al supervisor destinatario.
 * Deja de mostrarse cuando abre su solapa Viáticos (Logistics.jsx marca seen_at ahí). */
export default function ViaticoAlertBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => { (async () => {
    try { const r = await api.get("/viaticos/unseen"); setItems(r.data); } catch { /* silencioso, no bloquea el inicio */ }
  })(); }, []);

  if (!items.length) return null;
  const v = items[0];

  return (
    <Link to="/supervisor/logistica?tab=viaticos" data-testid="viatico-alert-banner" style={{
      display: "flex", alignItems: "center", gap: 10, marginTop: 14, position: "relative", zIndex: 1,
      background: "rgba(255,251,244,0.1)", border: "1px solid rgba(255,251,244,0.25)", color: "#FFFBF4",
      padding: "10px 14px", borderRadius: 6, fontSize: 12, fontWeight: 700, textDecoration: "none",
    }}>
      <Wallet size={16} style={{ color: "#BF3437", flexShrink: 0 }} />
      <span>
        Se registró el pago de tus viáticos de {periodLabel(v.period)}: ${v.amount.toLocaleString("es-AR")}, el {v.payment_date}
        {items.length > 1 && ` (+${items.length - 1} más)`}
      </span>
    </Link>
  );
}
